import { User } from "@/types/models";

interface EntityTypeAndId {
  entityType: "district" | "school";
  entityId: string;
}

const getEntityForUserRole = (user: User): EntityTypeAndId => {
  if ("district_admin" in user && user.district_admin.district) {
    return {
      entityType: "district",
      entityId: user.district_admin.district.unique_id,
    };
  } else if ("school_admin" in user && user.school_admin.school) {
    return {
      entityType: "school",
      entityId: user.school_admin.school.unique_id,
    };
  } else {
    return {
      entityType: "school",
      entityId: user.schools[0]?.unique_id ?? "",
    };
  }
};

export default getEntityForUserRole;
